<template>
    <div class="mt-2">
        <button class="uppercase font-semibold text-blue-500 text-sm flex items-center"
            :class="[isImagesMax ? 'opacity-50' : 'opacity-100']" @click="openSelectImage">
            <img src="../../icons/uploadIcon.svg" class="mr-2" />
            upload</button>
        <input multiple @change="uploadImageAction" ref="formInputRef" type="file" accept="image/*" class="hidden" />
    </div>
</template>

<script>
export default {
    name: "package_iamge_upload",
    props: {
        updateStoreNoEvent: { type: Function },
        packageForm: { type: Object }
    },
    computed: {
        isImagesMax() {
            return this.packageForm.packageImages.length > 2
        }
    },
    methods: {
        async uploadImageAction(e) {
            if (this.isImagesMax) return;
            const file =  Array.from(e.target.files);

            if ((file.length + this.packageForm.packageImages.length) > 3) {
                this.generateToast("Maximum file upload, should be 3", "error");
                return;
            }
            else if (file) {
                // Example: Call a method to upload the image.
                file.forEach( async element => {
                    const responseUrl = await this.uploadImage(element);
                    this.updateStoreNoEvent(responseUrl, "packageImages")
                });
            }
        },
        openSelectImage() {
            if (this.isImagesMax) return;
            this.$refs.formInputRef?.click()
        }
    },
}
</script>

<style lang="scss" scoped></style>